module.exports = __webpack_public_path__ + "img/logo3.4acf6b7d.png";